<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <button class="btn btn-primary" @click="$refs.add_capability_modal.open()">{{ 'capabilities_add' | t }}</button>
    </div>
    <div class="container-fluid" v-if="capabilities.length > 0">
      <div class="row card mb-2 flex-row pt-4 pb-4">
        <div class="form-group col-3 mb-0">
          <label>Filter sender country</label>
          <select class="form-control" v-model="sender_country">
            <option v-for="c in countries" :value="c.code">{{ c.name }}</option>
          </select>
        </div>
        <div class="form-group col-3 mb-0">
          <label>Filter receiver country</label>
          <select class="form-control" v-model="delivery_country">
            <option v-for="c in countries" :value="c.code">{{ c.name }}</option>
          </select>
        </div>
      </div>
      <div class="row mt-3">
        <template v-for="option in capabilities">
          <div class="col-4 card">
            <div class="card-body">
              <template v-if="option.customer_specific_services">
                <div class="alert alert-dark mb-0">
                  <p>This carrier has customer specific services.</p>
                  <p>Current list is shown with webshipper test credentials (if any present)</p>
                  <button class="btn btn-primary" @click="open_customer_specific_services_modal(option)">
                    Click to add customer specific information
                  </button>
                </div>
              </template>
              <table class="table table-responsive"></table>
              <tbody>
                <tr>
                  <td colspan="2">
                    <img class="img-thumb" v-if="option.fulfillment_logo" :src="option.fulfillment_logo" /><img
                      class="img-thumb"
                      v-else
                      :src="option.list_logo"
                    />
                  </td>
                </tr>
                <template v-for="(val, key) in option">
                  <tr
                    v-if="
                      (option.type == 'order_channel_types' && !excluded_oc_types_options.includes(key)) ||
                      (option.type == 'carrier_types' && !excluded_carrier_types_options.includes(key))
                    "
                  >
                    <td v-if="key.endsWith('_url')">
                      <p>
                        <strong>{{ ('supports_' + key) | t }}</strong>
                      </p>
                    </td>
                    <td v-else-if="key !== 'services'">
                      <p>
                        <strong>{{ key | t }}</strong>
                      </p>
                    </td>
                    <template v-if="key == 'services'">
                      <td colspan="2">
                        <strong>{{ key | t }}</strong>
                        <template v-if="filtered_services(option).length == 0">
                          <div class="alert alert-info mt-3">
                            No services present at current. You might have to add customer specific information to load
                            services from the selected carrier
                          </div>
                        </template>
                        <template v-if="filtered_services(option).length > 0"
                          ><small>Click service to see add ons</small>
                          <table class="table">
                            <thead>
                              <th colspan="2">Service (service code)</th>
                            </thead>
                            <tbody>
                              <tr v-for="service in filtered_services(option)">
                                <td>
                                  <a data-toggle="collapse" :href="'#collapse_' + service.service_code"
                                    >{{ service.service_name }} ({{ service.service_code }})
                                    <div class="collapse" :id="'collapse_' + service.service_code">
                                      <small v-if="service.add_ons" v-for="add_on in service.add_ons"
                                        >- {{ add_on.add_on_name }} ({{ add_on.add_on_code }})</small
                                      >
                                    </div></a
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </td>
                    </template>
                    <template v-else>
                      <td v-if="typeof val == 'boolean' || val == null">
                        <i class="fa fa-check-circle text-success" v-if="val"></i
                        ><i class="fa fa-times-circle text-danger" v-else></i>
                      </td>
                      <td v-else-if="key.endsWith('_url')">
                        <i class="fa fa-check-circle text-success" v-if="val && val.length > 0"></i
                        ><i class="fa fa-times-circle text-danger" v-else></i>
                      </td>
                      <td v-else-if="typeof val == 'string'">{{ val }}</td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </div>
          </div>
        </template>
      </div>
      <capabilities-customer-specific-services-modal
        v-on:load_custom_services="load_custom_services($event)"
        ref="customer_specific_services_modal"
      ></capabilities-customer-specific-services-modal>
    </div>
    <no-result v-else :text="$i18n.t('no_capabilities')"></no-result>
    <capabilities-add-cabalitity-modal
      ref="add_capability_modal"
      v-on:add_cabability="add_capability_column($event)"
    ></capabilities-add-cabalitity-modal>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import config from '../../config/index';
let global_countries = require('i18n-iso-countries');

export default {
  mounted() {
    this.setBreadcrumbs([{ to: { name: 'capabilities' }, text: 'capabilities' }]);
    if (this.capabilities.length === 0) {
      this.$refs.add_capability_modal.open();
    }
  },
  data: function () {
    return {
      selected_capability_options: [],
      sender_country: '',
      delivery_country: '',
      excluded_oc_types_options: [
        'description',
        'global_attrs',
        'id',
        'links',
        'list_logo',
        'local_attrs',
        'meta',
        'type',
        'links',
        'fulfillment_job_name',
        'component_name',
        'support_url',
        'module_link',
        'onboarding_url'
      ],
      excluded_carrier_types_options: [
        'booking_endpoint_url',
        'waybill_endpoint_url',
        'is_public',
        'service_list_url',
        'service_quote_url',
        'eod_url',
        'carrier_code',
        'list_logo',
        'fulfillment_logo',
        'specification_version',
        'pickup_url',
        'address_validation_validators',
        'address_validation_filters',
        'tracking_url',
        'tracking_edi_url',
        'exclude_billing',
        'check_rotation',
        'shipment_updates_limit_minutes',
        'barcode_mail',
        'order_barcode_mail_template',
        'meta',
        'links',
        'validation_endpoint_url',
        'type',
        'id',
        'local_attrs',
        'global_attrs',
        'description',
        'required_details',
        'requires_dutiable',
        'customer_specific_attributes',
        'disable_prequote',
        'customer_specific_services',
        'cost_lines',
        'drop_point_support',
        'onboarding_url'
      ]
    };
  },
  computed: {
    countries() {
      let countries = global_countries.getNames(config.locale);
      return _.chain(countries)
        .map((name, code) => {
          return { code: code, name: name };
        })
        .sortBy(['name', 'asc'])
        .unshift({ code: '', name: '' })
        .unshift({ code: 'DK', name: countries.DK })
        .unshift({ code: 'GB', name: countries.GB })
        .value();
    },
    capabilities() {
      return this.selected_capability_options;
    }
  },
  methods: {
    supports_service_code(capability, service_code) {
      return true;
    },
    filtered_services(capability) {
      return _.filter(capability.services, (s) => {
        return (
          s.country_combinations == null ||
          _.some(s.country_combinations, (cc) => {
            if (cc == null) return true;

            if (this.sender_country.length > 0) {
              if (this.delivery_country.length > 0) {
                return (
                  cc.sender_country == this.sender_country &&
                  (cc.recipient_countries.includes('ALL') || cc.recipient_countries.includes(this.delivery_country))
                );
              }
              return cc.sender_country == this.sender_country;
            } else {
              return true;
            }
          })
        );
      });
    },
    async add_capability_column(capability) {
      if (capability.type == 'carrier_types') {
        let quote = await this.get_capability(capability);
        capability.services = quote.services;
      }
      this.selected_capability_options.push(capability);
    },
    async get_capability(capability) {
      let { data } = await Api.create('capabilities', {
        carrier_code: capability.carrier_code,
        customer_specific_attributes: capability.customer_specific_attributes
      });
      return data;
    },
    open_customer_specific_services_modal(capability) {
      this.$refs.customer_specific_services_modal.open(capability);
    },
    async load_custom_services(capability) {
      let capability_quote = await this.get_capability(capability);
      this.$set(capability, 'services', capability_quote.services);
      this.sender_country = 'DK';
    }
  }
};
</script>

<style scoped>
.fa {
  font-size: 25px;
}
.table thead th,
.table thead td {
  border: none;
}
small {
  display: block;
}
.table tbody tr:first-child td {
  border-top-color: transparent;
}
</style>
